/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

import _categoryListWithProducts from './_categoryListWithProducts.graphql';

import {
    categoryById,
    categoryList,
    categoryWithChildren,
    productBySku,
    productsByCategory,
    productsByFilter,
    productSearch,
    productsInCategory,
    productWithVariantProperties,
    productWithVariants,
    storeConfig
} from '../2.3.5';

export {
    categoryById,
    categoryList,
    _categoryListWithProducts,
    categoryWithChildren,
    productBySku,
    productsByCategory,
    productsByFilter,
    productSearch,
    productsInCategory,
    productWithVariantProperties,
    productWithVariants,
    storeConfig
};

export default {
    categoryById,
    categoryList,
    _categoryListWithProducts,
    categoryWithChildren,
    productBySku,
    productsByCategory,
    productsByFilter,
    productSearch,
    productsInCategory,
    productWithVariantProperties,
    productWithVariants,
    storeConfig
};
